export const getOperatingSystem = () => {
  const os = navigator.userAgent;
  let displayOs = '';

  if (os.search('Windows') !== -1) {
    displayOs = 'Windows';
  } else if (os.search('Mac') !== -1) {
    displayOs = 'macOS';
  } else if (os.search('X11') !== -1 && !(os.search('Linux') !== -1)) {
    displayOs = 'UNIX';
  } else if (os.search('Linux') !== -1 && os.search('X11') !== -1) {
    displayOs = 'Linux';
  }

  return displayOs;
};

export const userOperatingSystem = getOperatingSystem();
export const isMacOs = userOperatingSystem === 'macOS';
export const isLinux = userOperatingSystem === 'Linux';
export const isWindows = userOperatingSystem === 'Windows';
